// @flow

import * as React from 'react';
import { featureIsEnabled } from '@ta/common.features';
import { connect } from 'react-redux';
import { ACTIONS } from '@ta/social.onboarding-state';
import { localize } from '@ta/common.i18n';
import { CdnImage } from '@ta/common.cdn';
import useLogin from '@ta/login.login';
import { useGARecorder } from '@ta/platform.interactions';
import classNames from '@ta/common.classnames';
import styles from './ProfileSectionNarrowLogout.less';

const PID = 40614;
const MODULE = 'left_rail_profile_section_non_member';

type Props = {|
  setShouldFire: Function,
|};

const ProfileSectionNarrowLogout = (props: Props) => {
  const { setShouldFire } = props;
  const track = useGARecorder();
  const login = useLogin();
  const onSignUpClick = React.useCallback(() => {
    track({
      module: MODULE,
      action: 'sign_up_click',
    });
    login({
      pid: PID,
      flowOrigin: 'join',
      flow: 'CORE_COMBINED',
    }).then(result => {
      // only fire onboarding on homepage and if a user was actually created (onSuccess is called
      // even if the user refuses the terms and conditions, not creating a member!)
      if (result && result.userId) {
        setShouldFire(false, 'HOMEPAGE_LEFT_RAIL');
      }
    });
  }, [track, login, setShouldFire]);

  return (
    <div className={`ui_card message ${styles.sectionLogout}`}>
      <CdnImage
        className={styles.sectionLogoutImage}
        src="/img2/social/Avatar_stock_PNG_v3.png"
        alt=""
      />
      <div className={styles.sectionLogoutTitle}>
        {/* Unlock the best of TripAdvisor */}
        {localize('memx_onboarding_unlock_TA')}
      </div>
      <ul className={styles.sectionLogoutList}>
        <li className={styles.listItemContainer}>
          <span className={styles.listCircle} />
          <div className={styles.listText}>
            {/* Save your favorite travel ideas and see them on a map */}
            {localize('Homepage_leftrail_subhead1')}
          </div>
        </li>
        <li className={styles.listItemContainer}>
          <span className={styles.listCircle} />
          <div className={styles.listText}>
            {/* Get price alerts and deals so you can travel your way */}
            {localize('Homepage_leftrail_subhead2')}
          </div>
        </li>
        <li className={styles.listItemContainer}>
          <span className={styles.listCircle} />
          <div className={styles.listText}>
            {/* Ask questions and get answers from travelers like you */}
            {localize('Homepage_leftrail_subhead3')}
          </div>
        </li>
      </ul>
      <div className={styles.buttonWrapper}>
        <button
          className={classNames('ui_button', 'fullwidth', styles.customButtonType)}
          onClick={onSignUpClick}
        >
          {!featureIsEnabled('daodao_unify_nav_links_title')
            ? localize('civ_figs_signup_010') /* Sign Up */
            : localize('reg_and_join') /* Join */}
        </button>
      </div>
    </div>
  );
};

export default connect<Props, {||}, _, _, _, _>(
  null,
  {
    setShouldFire: ACTIONS.setShouldFire,
  },
)(ProfileSectionNarrowLogout);
